import { useTheme } from '@shopify/restyle';
import { Row } from 'app/design/primitives/box';
import type { Theme } from 'app/shopify';
import { IconUserCircle } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';

export function EmptyReferralSlots() {
  const theme = useTheme<Theme>();
  return (
    <Row
      alignItems="center"
      alignSelf="center"
      flexWrap="wrap"
      gap="spacing.general.x4"
      style={{ justifyContent: 'center', marginBottom: theme.spacing['spacing.general.x4'] }}
    >
      <IconUserCircle strokeWidth={ICON_STROKE_WIDTH} />
      <IconUserCircle strokeWidth={ICON_STROKE_WIDTH} />
      <IconUserCircle strokeWidth={ICON_STROKE_WIDTH} />
      <IconUserCircle strokeWidth={ICON_STROKE_WIDTH} />
      <IconUserCircle strokeWidth={ICON_STROKE_WIDTH} />
    </Row>
  );
}
